import React, { useState } from 'react';
import './EscanearFicha.css';

const EscanearFicha = ({ onDatosExtraidos, onClose }) => {
  const [imagen, setImagen] = useState(null);
  const [procesando, setProcesando] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImagen(file);
    }
  };

  const procesarImagen = async () => {
    if (!imagen) {
      alert('Por favor selecciona una imagen primero');
      return;
    }

    setProcesando(true);
    
    // Simular procesamiento de imagen
    // En una implementación real, aquí iría la lógica de OCR
    setTimeout(() => {
      const datosEjemplo = {
        lejos_esf_od: "-2.50",
        lejos_cil_od: "-1.00",
        lejos_eje_od: "90",
        lejos_esf_oi: "-2.75",
        lejos_cil_oi: "-0.75",
        lejos_eje_oi: "85"
      };
      
      onDatosExtraidos(datosEjemplo);
      setProcesando(false);
      onClose();
    }, 2000);
  };

  return (
    <div className="escanear-ficha-overlay">
      <div className="escanear-ficha-modal">
        <div className="escanear-ficha-header">
          <h3>Escanear Ficha Oftalmológica</h3>
          <button onClick={onClose} className="close-button">×</button>
        </div>
        
        <div className="escanear-ficha-content">
          <div className="upload-area">
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="file-input"
              id="imagen-upload"
            />
            <label htmlFor="imagen-upload" className="upload-label">
              {imagen ? imagen.name : "Seleccionar imagen de la ficha"}
            </label>
          </div>
          
          {imagen && (
            <div className="preview-area">
              <img
                src={URL.createObjectURL(imagen)}
                alt="Preview"
                className="image-preview"
              />
            </div>
          )}
        </div>
        
        <div className="escanear-ficha-actions">
          <button onClick={onClose} className="btn-secondary">
            Cancelar
          </button>
          <button 
            onClick={procesarImagen} 
            disabled={!imagen || procesando}
            className="btn-primary"
          >
            {procesando ? 'Procesando...' : 'Extraer Datos'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EscanearFicha;